@let obs =
  {
    loading: loading$ | async,
    added: hasEntry$ | async,
  };

<div data-testid="productGridItemComparisonButton" class="comparison" (click)="!obs.loading && addOrRemoveEntry()">
  <div class="comparison-icon-block">
    <sd-icon class="icon-size-xs icon-size-md-s icon-size-lg-m" [class.active]="obs.added" type="fat-simile"></sd-icon>
  </div>
</div>
